import React, { useState, useCallback, useRef, useMemo, useEffect } from 'react';
import moment from 'moment';
import { getPageData } from '@/pages/intelligence/services/marketProfile';
import { fetchGenreMarketProfiles } from '@intelligence/v3/services/genreMarketProfile';
import {
  formatEnTimeByStr,
  fixLineData,
  computePrecentChange,
  sortTimeDesc,
  sortArrDesc,
  computePrecent,
  sortTime,
  computeSpecialPercent,
} from '@/pages/intelligence/pages/MarketProfile/_util';
import * as echarts from 'echarts';
import defaltCountryImg from '@/pages/home/assets/img/flag/default.svg';
import alt170170 from '@/pages/intelligence/assets/imgs/170170.png';
import alt280350 from '@/pages/intelligence/assets/imgs/280350.png';
import alt460215 from '@/pages/intelligence/assets/imgs/460215.png';
import { history, useIntl } from 'umi';
import { toDateTypeLy } from '@/pages/intelligence/utils/common';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
// import { changeParamsMetricList, changeResDatasMetricList } from './util';

const initOrder = {
  gameRevenueA: 'desc',
  gameRevenueAChange: 'desc',
  gameRevenueS: 'desc',
  gameRevenueSChange: 'desc',
  gameDownloadA: 'desc',
  gameDownloadAChange: 'desc',
  gameDownloadS: 'desc',
  gameDownloadSChange: 'desc',
  gameMAUA: 'desc',
  gameMAUAChange: 'desc',
  gameMAUS: 'desc',
  gameMAUSChange: 'desc',
  gameRevenueD: 'desc',
  gameRevenueDChange: 'desc',
  gameRevenueP: 'desc',
  gameRevenuePChange: 'desc',
  MAU: 'desc',
  MAUChange: 'desc',
};
export default function useStatsModal(props: any) {
  const { marketName, changeSegment, countryId, regionOptions, genreMap } = props;
  const [dataSource, setDataSource] = useState('sensortower');
  const [mainGenreList, setMainGenreList] = useState(['All']);
  const [gameType, setGameType] = useState('mobile'); // gameType
  const [dataType, setDataType] = useState('operation'); // dataType
  const [trendType, setTrendType] = useState('revenue');
  const { locale, formatMessage } = useIntl();
  const gamesParams = useRef({
    data_tag: 'games_trend',
    end_date: '2023-01-01',
    entity_type: 'mobile',
    genre: [],
    granularity: 'monthly',
    iegg_genre_req: [],
    market: 'us',
    order: 'desc',
    order_by: 'annie_revenue',
    page: 1,
    page_size: 50,
    start_date: '2022-02-01',
  });
  // filter部分
  const [value, setValue] = useState<any>([]);
  const [dateType, setDateType] = useState('month');
  const [subValue, setSubValue] = useState([]);
  const [downloadOrder, setDownloadOrder] = useState('');
  const [downloadDataTag, setDownloadDataTag] = useState('');

  const genreRef = useRef(null);
  const [mainGenres, setMainGenres] = useState([]);
  const [subGenres, setSubGenres] = useState([]);

  // statTrends 部分
  const [sumRevenue, setSumRevenue] = useState(0);
  const [sumDownload, setSumDownload] = useState(0);

  // 搜索框部分
  const SearchBoxRef = useRef();
  const [searchKey, setSearchKey] = useState([]);
  const [searchData, setSearchData] = useState<any[]>([]);

  // table部分
  const [showTableData, setShowTableData] = useState<any[]>([]);
  // 表格所有的数据，用于筛选、排序等，不用再次调用接口
  const [allTableData, setAllTableData] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(1);
  const [sortColunms, setSortColunms] = useState(['date']);
  const [sortOrder, setSortOrder] = useState(initOrder);
  const [tableLength, setTableLength] = useState(0);

  const [lineDataLoad, setLineDataLoad] = useState(true);
  const [tableDataLoad, setTableDataLoad] = useState(true);

  //
  const [gameTrendsData, setGameTrendsData] = useState({});
  const [operationTrendsData, setOperationTrendsData] = useState({});

  const MOBILE_DEFAULT_SORT_KEY = 'annie_revenue';
  const PC_AND_CONSOLE_DEFAULT_SORT_KEY = 'digital_revenue';

  const gameSortRelation = {
    gameRevenueA: MOBILE_DEFAULT_SORT_KEY,
    gameRevenueAChange: 'annie_revenue_ratio',
    gameRevenueS: 'sensor_revenue',
    gameRevenueSChange: 'sensor_revenue_ratio',
    gameDownloadA: 'annie_download',
    gameDownloadAChange: 'annie_download_ratio',
    gameDownloadS: 'sensor_download',
    gameDownloadSChange: 'sensor_download_ratio',
    gameMAUA: 'annie_mau',
    gameMAUAChange: 'annie_mau_ratio',
    gameMAUS: 'sensor_mau',
    gameMAUSChange: 'sensor_mau_ratio',
    gameRevenueD: PC_AND_CONSOLE_DEFAULT_SORT_KEY,
    gameRevenueDChange: 'digital_revenue_ratio',
    gameRevenueP: 'physical_revenue',
    gameRevenuePChange: 'physical_revenue_ratio',
    MAU: 'mau',
    MAUChange: 'mau_ratio',
  } as any;

  const gameSortRelationReverse = {
    MOBILE_DEFAULT_SORT_KEY: 'gameRevenueA',
    annie_revenue_ratio: 'gameRevenueAChange',
    sensor_revenue: 'gameRevenueS',
    sensor_revenue_ratio: 'gameRevenueSChange',
    gameDownloadA: 'annie_download',
    annie_download_ratio: 'gameDownloadAChange',
    sensor_download: 'gameDownloadS',
    sensor_download_ratio: 'gameDownloadSChange',
    annie_mau: 'gameMAUA',
    annie_mau_ratio: 'gameMAUAChange',
    sensor_mau: 'gameMAUS',
    sensor_mau_ratio: 'gameMAUSChange',
    PC_AND_CONSOLE_DEFAULT_SORT_KEY: 'gameRevenueD',
    digital_revenue_ratio: 'gameRevenueDChange',
    physical_revenue: 'gameRevenueP',
    physical_revenue_ratio: 'gameRevenuePChange',
    mau: 'MAU',
    mau_ratio: 'MAUChange',
  } as any;

  // 添加表格展开*********************
  const [expandedKeys, setExpandedKeys] = useState([]);
  // 展开国家下探需要的参数
  const [selectId, setSelectId] = useState('');

  const [selectChildren, setSelectChildren] = useState([]);

  const [gameSortFiled, setGameSortFiled] = useState([MOBILE_DEFAULT_SORT_KEY]);

  const color = [
    '#376AE7',
    '#3ECBFF',
    '#4FCB87',
    '#FFD14E',
    '#ED9142',
    '#E95F6A',
    '#CF61AC',
    '#8164CD',
    '#6585F7',
    '#A0B6FA',
    '#3ba272',
  ];

  const pcColor = [
    '#376AE7',
    '#3ECBFF',
    '#4FCB87',
    '#FFD14E',
    '#ED9142',
    '#E95F6A',
    '#CF61AC',
    '#8164CD',
    '#6585F7',
    '#A0B6FA',
    '#3ba272',
  ];

  const [selectedKeysColor, setSelectedKeysColor] = useState({});
  //
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedAllKeys, setSelectedAllKeys] = useState([]);
  const [ieggGenre, setIeggGenre] = useState([]);

  const isAnnie: any = useMemo(() => {
    return history.location.query?.isAnnie;
  }, [history.location]);

  const getGenreDisplayName = (genreName: string, genreType: 'main' | 'sub' = 'main') => {
    if (!genreName) {
      return '';
    }

    if (locale !== LANGUAGE_CN) {
      return genreName;
    }

    const currentGenreMap = genreMap?.[genreType] || {};
    const matchedGenre = currentGenreMap?.[genreName.toLowerCase()];
    return matchedGenre?.genre_cn || genreName;
  };

  const getGenreDisplayValue = (
    genreValue: string | string[] | null | undefined,
    genreType: 'main' | 'sub',
  ) => {
    if (Array.isArray(genreValue)) {
      return genreValue.map((item) => getGenreDisplayName(item, genreType));
    }

    if (!genreValue) {
      return genreValue;
    }

    return genreValue.split('|').map((item) => getGenreDisplayName(item, genreType));
  };

  const formatGameGenreDisplayRow = (item: any) => {
    return {
      ...item,
      mainGenreDisplay: getGenreDisplayValue(item.mainGenre, 'main'),
      subGenreDisplay: getGenreDisplayValue(item.subGenre, 'sub'),
    };
  };

  const formatGenreDisplayRow = (item: any) => {
    return {
      ...item,
      displayName: getGenreDisplayName(item.name, 'main'),
      children: item.children?.map((child: any) => {
        return {
          ...child,
          displayName: getGenreDisplayName(child?.name || child?.Name, 'sub'),
        };
      }),
    };
  };

  const formatGenreDisplayTrendData = (trendData: IRecord<any>) => {
    return Object.keys(trendData || {}).reduce((result, key) => {
      if (key === 'xAxis') {
        result[key] = trendData[key];
        return result;
      }

      result[key] = {
        ...trendData[key],
        chartDisplayName: getGenreDisplayName(trendData[key]?.rawName || trendData[key]?.name, 'main'),
      };
      return result;
    }, {} as IRecord<any>);
  };

  // 当tab是by games，获取默认的排序字段
  const getDefaultSortkeyWhenGames = (type: string) =>
    type === 'mobile' ? MOBILE_DEFAULT_SORT_KEY : PC_AND_CONSOLE_DEFAULT_SORT_KEY;

  /**
   * 查询operation数据
   * @param {*} params 查询参数
   * @param {*} flag 是否需要设置默认时间
   */
  const getOperationData = async (params: any, flag: any) => {
    setLineDataLoad(true);
    setTableDataLoad(true);
    params.data_tag = 'operation';
    if (params.entity_type == 'mobile' && isAnnie) {
      params.is_annie = isAnnie == '1';
    }

    const oprerationRes = await getPageData('detail/stats_rank', params);
    // 转换新接口参数
    // const newParams = changeParamsMetricList(params, params?.data_tag, false);
    // const newParams = changeParamsMetricList(params, params?.data_tag, true);
    // const oprerationResTemp = await fetchGenreMarketProfiles(newParams);
    // // 转换新接口,返回数据格式
    // const oprerationRes = changeResDatasMetricList(oprerationResTemp);

    const tempTableData = [] as any;
    const xAxis = [] as any;
    let revData = [] as any;
    let downData = [] as any;
    let sumRev = 0;
    let sumDown = 0;

    const tempData = oprerationRes?.opreatio_ranks?.opreatio_rank;
    const preData = oprerationRes?.opreatio_ranks?.pre_opreatio_rank;
    if (tempData) {
      tempData.map((item, index) => {
        if (params.entity_type == 'mobile') {
          const rev_precent = computeSpecialPercent(
            item,
            preData,
            'rev',
            'pre_rev',
            params.granularity,
          );
          const download_precent = computeSpecialPercent(
            item,
            preData,
            'download',
            'pre_dl',
            params.granularity,
          );
          const obj = {
            date: moment(item.date).format(
              params.granularity !== 'monthly' ? 'YYYY-MM-DD' : 'YYYY-MM',
            ),
            revenue: item.rev,
            revenueChange: rev_precent,
            download: item.download,
            downloadChange: download_precent,
          };
          tempTableData.push(obj);
          xAxis.push(
            moment(item.date).format(params.granularity !== 'monthly' ? 'YYYY-MM-DD' : 'YYYY-MM'),
          );
          revData = fixLineData(revData, index);
          downData = fixLineData(downData, index);
          revData.push(Math.floor(item.rev) == 0 ? '-' : Math.floor(item.rev));
          downData.push(Math.floor(item.download) == 0 ? '-' : Math.floor(item.download));
          sumRev += item.rev;
          sumDown += item.download;
        } else {
          const rev_precent = computeSpecialPercent(
            item,
            preData,
            'digtal_rev',
            'pre_digtal_rev',
            params.granularity,
          );
          const download_precent = computeSpecialPercent(
            item,
            preData,
            'physical_rev',
            'pre_physical_rev',
            params.granularity,
          );
          const digRev = Math.floor(item.digtal_rev);
          const phyRev = Math.floor(item.physical_rev);
          const obj = {
            date: moment(item.date).format(
              params.granularity !== 'monthly' ? 'YYYY-MM-DD' : 'YYYY-MM',
            ),
            revenueDigital: digRev,
            revenueDigitalChange: rev_precent,
            revenuePhysical: phyRev,
            revenuePhysicalChange: download_precent,
          };
          tempTableData.push(obj);
          xAxis.push(
            moment(item.date).format(params.granularity !== 'monthly' ? 'YYYY-MM-DD' : 'YYYY-MM'),
          );
          revData = fixLineData(revData, index);
          downData = fixLineData(downData, index);
          revData.push(digRev == 0 ? '-' : digRev);
          downData.push(phyRev == 0 ? '-' : phyRev);
          sumRev += item.digtal_rev + item.physical_rev;
        }
      });

      setTableLength(tempData?.length || tempData.total_size || 0);
    }

    if (flag) {
      if (
        oprerationRes?.opreatio_ranks?.start_date &&
        oprerationRes?.opreatio_ranks?.end_date &&
        oprerationRes?.opreatio_ranks?.end_date != '1970-01-01'
      ) {
        setValue([
          moment(oprerationRes?.opreatio_ranks?.start_date),
          moment(oprerationRes?.opreatio_ranks?.end_date),
        ]);
      } else {
        setValue([moment(), moment()]);
      }
    }

    tempTableData.sort(sortTimeDesc('date'));
    showTableData.length = 0;
    showTableData.push(...tempTableData);
    setShowTableData(showTableData);

    allTableData.length = 0;
    allTableData.push(...tempTableData);
    setAllTableData(allTableData);

    const data = [
      {
        name:
          params.entity_type == 'mobile'
            ? formatMessage({ id: 'dbi_total_rev_$' })
            : formatMessage({ id: 'dbi_metric_digitalRevenue' }),
        type: 'line',
        color: '#6585F7',
        data: revData,
      },
      {
        name:
          params.entity_type == 'mobile'
            ? formatMessage({ id: 'dbi_downloads' })
            : formatMessage({ id: 'dbi_metric_physical_revenue' }),
        type: 'line',
        color: '#4397C5',
        data: downData,
      },
    ];

    if (xAxis.length != 0) {
      const chart = document.getElementById('trendLine');
      // console.log('chart-dom',chart);
      setOperationTrendsData({ data, xAxis });
      // drawLineChart2('trendLine', data, xAxis);
    } else {
      setOperationTrendsData({ data: [], xAxis: [] });
    }
    filterData(searchKey.length > 0 ? searchKey[0] : '');
    setLineDataLoad(false);
    setTableDataLoad(false);
    // 最后一项是最新数据，需要赋值SumRevenue、SumDownload及最新数据时间
    setSumRevenue(sumRev);
    setSumDownload(sumDown);
  };

  /**
   * 查询game可视化数据
   * @param {*} selectCode 选中的游戏
   */
  const getGamesTrendData = async (selectCode: string[]) => {
    setLineDataLoad(true);
    const params = gamesParams.current;
    try {
      const gamesTrend = await getPageData('detail/stats_rank', {
        ...params,
        select_code: selectCode,
        data_tag: 'games_trend',
      });
      // const newParams = changeParamsMetricList({
      //   ...params,
      //   app_ids: selectCode,
      // }, 'games', true);
      // const resTemp = await fetchGenreMarketProfiles(newParams);
      // // 转换新接口,返回数据格式
      // const gamesTrend = changeResDatasMetricList(resTemp);

      let selectedKeysTemp = [] as any;
      const selectedKeysColorTemp: any = {};
      const tempTrendsData: any = {};
      const tempXaxis = [] as any;
      const trendsData = gamesTrend?.games_ranks?.market_detail_stats_games_trend;
      if (trendsData) {
        const dataLength = trendsData.length;
        trendsData.sort(sortTime('date')).map((item, key) => {
          if (item.game_trends) {
            tempXaxis.push(
              moment(item.date).format(params.granularity !== 'monthly' ? 'YYYY-MM-DD' : 'YYYY-MM'),
            );
            if (params.entity_type == 'mobile') {
              item.game_trends.map((obj) => {
                const appId = obj.app_id;
                const appIdData = tempTrendsData[appId] || {};
                // revenue数据
                let appIdRevenuData = appIdData.revenue || [];
                if (appIdRevenuData.length < dataLength) {
                  appIdRevenuData = fixLineData(appIdRevenuData, key);
                  appIdRevenuData.push(obj.rev == 0 ? '-' : obj.rev);
                  appIdData.revenue = appIdRevenuData;
                }

                // download数据
                let appIdDownloadData = appIdData.download || [];
                if (appIdDownloadData.length < dataLength) {
                  appIdDownloadData = fixLineData(appIdDownloadData, key);
                  appIdDownloadData.push(obj.download == 0 ? '-' : obj.download);
                  appIdData.download = appIdDownloadData;
                }

                // MAU数据
                let appIdMauData = appIdData.MAU || [];
                if (appIdMauData.length < dataLength) {
                  appIdMauData = fixLineData(appIdMauData, key);
                  appIdMauData.push(obj.mau == 0 ? '-' : obj.mau);
                  appIdData.MAU = appIdMauData;
                }

                //
                appIdData.name = obj.name;
                tempTrendsData[appId] = appIdData;
              });
            } else {
              item.game_trends.map((obj: any) => {
                const appId = obj.app_id;
                const appIdData = tempTrendsData[appId] || {};
                // digital revenue数据 ---  使用的是digital revenue的值
                let appIdRevenuData_d = appIdData.revenue || [];
                if (appIdRevenuData_d.length < dataLength) {
                  appIdRevenuData_d = fixLineData(appIdRevenuData_d, key);
                  appIdRevenuData_d.push(obj.digtal_rev == 0 ? '-' : obj.digtal_rev.toFixed(2));
                  appIdData.revenue = appIdRevenuData_d;
                }

                // phycial revenue数据
                let appIdRevenuData_p = appIdData.revenueP || [];
                if (appIdRevenuData_p.length < dataLength) {
                  appIdRevenuData_p = fixLineData(appIdRevenuData_p, key);
                  appIdRevenuData_p.push(obj.physical_rev == 0 ? '-' : obj.physical_rev.toFixed(2));
                  appIdData.revenueP = appIdRevenuData_p;
                }

                // MAU数据
                let appIdMauData = appIdData.MAU || [];
                if (appIdMauData.length < dataLength) {
                  appIdMauData = fixLineData(appIdMauData, key);
                  appIdMauData.push(obj.mau == 0 ? '-' : obj.mau);
                  appIdData.MAU = appIdMauData;
                }

                appIdData.name = obj.name;
                tempTrendsData[appId] = appIdData;
              });
            }
          }
          if (!tempTrendsData?.xAxis || tempTrendsData?.xAxis?.length == 0) {
            tempTrendsData.xAxis = tempXaxis;
          }
        });
      }

      selectedKeysTemp = selectCode?.map((item, index) => {
        selectedKeysColorTemp[item] =
          params.entity_type === 'mobile' ? color[index] : pcColor[index];
        return {
          gameId: item,
          color: params.entity_type === 'mobile' ? color[index] : pcColor[index],
        };
      });
      setGameTrendsData(tempTrendsData);
      setSelectedKeys(selectedKeysTemp);
      setSelectedAllKeys(selectedKeysTemp);
      setSelectedKeysColor(selectedKeysColorTemp);
      setLineDataLoad(false);
    } catch (error) {
      console.log(error);
    }
  };
  /**
   * 查询game数据
   * @param {*} params 参数
   * @param {*} flag 是否需要设置默认时间
   * @param {*} changePage 是否是改变分页等触发的,如果是分页触发，不需要筛选前6条折线图数据
   * @param {*}  是否是改变分页等触发的,如果是分页触发，不需要筛选前6条折线图数据
   */
  const getGamesData = async (params: any, flag: any, changePage = false) => {
    !changePage && setLineDataLoad(true);
    setTableDataLoad(true);
    setShowTableData([]);
    params.data_tag = 'games';

    const gamesRes = await getPageData('detail/stats_rank', params);
    gamesParams.current = { ...params, data_tag: 'games_trend' };
    const tempTableData = [] as any;
    const selectedKeysTemp = changePage ? selectedKeys : ([] as any);
    const selectedKeysColorTemp = changePage ? { ...selectedKeysColor } : ({} as any);
    const tempData = gamesRes?.games_ranks;
    setDownloadDataTag('games');
    if (tempData) {
      const rankData =
        tempData[
        params.entity_type == 'mobile'
          ? 'market_detail_stats_games_ranks'
          : 'market_detail_stats_pc_games_ranks'
        ];
      const selectedGame = rankData?.slice(0, 6)?.map((item) => item?.app_id) || [];
      !changePage && (await getGamesTrendData(selectedGame));
      if (rankData) {
        rankData.map((item: any, index: number) => {
          let itemHasData = true;
          let { cover } = item;
          if (!cover) {
            cover =
              params.entity_type == 'mobile'
                ? alt170170
                : params.entity_type == 'pc'
                  ? alt460215
                  : alt280350;
          }
          let temp = {};
          if (params.entity_type == 'mobile') {
            temp = {
              downloadsSensor: item.sensor_dl,
              MAUSensor: item.sensor_mau,
              revenueAppannieChange: item.app_rev_ratio,
              MAUAppannie: item.appannie_mau,
              downloadsAppannieChange: item.app_dl_ratio,
              revenueSensorChange: item.sensor_rev_ratio,
              revenueSensor: item.sensor_rev,
              downloadsSensorChange: item.sensor_dl_ratio,
              gameIcon: cover,
              MAUAppannieChange: item.app_mau_ratio,
              revenueAppannie: item.appannie_rev,
              downloadsAppannie: item.appannie_dl,
              subGenre: item.sub_genre,
              name: item.name,
              rank: (params.page - 1) * params.page_size + index + 1,
              mainGenre: item.genre,
              app_id: item.app_id,
              desc: item.publisher,
              MAUSensorChange: item.sensor_mau_ratio,
              conutryFlag: item.country_img,
            };
            itemHasData =
              item.appannie_rev ||
              item.sensor_rev ||
              item.appannie_dl ||
              item.sensor_dl ||
              item.appannie_mau ||
              item.sensor_mau;
          } else {
            temp = {
              MAU: item.mau,
              revenuePhysicalChange: item.physical_ratio,
              gameIcon: cover,
              revenueDigitalChange: item.digtal_ratio,
              conutryName: `${item.location_city} ,${item.location_country}`,
              subGenre: item.sub_genre && item.sub_genre != '' ? item.sub_genre.split('|') : [],
              revenueDigital: item.digtal_rev,
              conutryFlag: item.country_img,
              name: item.name,
              rank: (params.page - 1) * params.page_size + index + 1,
              mainGenre: item.genre && item.genre != '' ? item.genre.split('|') : [],
              app_id: item.app_id,
              MAUChange: item.mau_ratio,
              revenuePhysical: item.physical_rev,
              platList: item.platform?.split('|') || [],
              desc: item.publisher,
            };

            itemHasData = item.digtal_rev || item.physical_rev || item.mau;
          }

          if (!changePage && selectedKeysTemp.length < 6) {
            let itemColor = '';
            if (params.entity_type == 'mobile') {
              itemColor = color[index];
            } else {
              itemColor = pcColor[index];
            }
            selectedKeysTemp.push({
              gameId: item.app_id,
              color: itemColor,
            });

            selectedKeysColorTemp[item.app_id] = itemColor;
          }
          // if (itemHasData) {
          tempTableData.push(formatGameGenreDisplayRow(temp));
          // }
        });
      }

      setPageIndex(params.page);
      setTableLength(tempData.total_size || 0);
    }

    if (flag) {
      if (tempData?.start_date && tempData?.end_date && tempData?.end_date != '1970-01-01') {
        setValue([moment(tempData.start_date), moment(tempData.end_date)]);
      } else {
        setValue([moment(), moment()]);
      }
    }
    setShowTableData(tempTableData);
    setAllTableData(tempTableData);
    setLineDataLoad(false);
    setTableDataLoad(false);
  };

  const getGenresData = async (params: any, flag: any, expandedKey?: any) => {
    setLineDataLoad(true);
    setTableDataLoad(true);
    params.data_tag = 'genres';
    const companyRes = await getPageData('detail/stats_rank', params);
    const tempTableData = [] as any;
    const tempTrendsData = {} as any;
    const selectedKeysTemp = [] as any;
    const selectedKeysColorTemp = {};
    const tempXaxis = [] as any;
    const tempData = companyRes?.genre_ranks;

    const searchDataTemp = [] as any;
    setDownloadDataTag('genres');
    if (tempData) {
      const rankData = tempData.market_detail_stats_genre_rank;
      if (rankData) {
        rankData
          .sort(sortArrDesc(gameType == 'mobile' ? 'rev' : 'digital_rev'))
          .map((item: any, index: number) => {
            const ch = item.children?.sort(sortArrDesc('name'));
            const obj = formatGenreDisplayRow({
              revenue: item.rev,
              download: item.download,
              name: item.genre_name,
              downloadChange: computePrecent(item.download, tempData.download_total),
              rank: index + 1,
              revenueChange: computePrecent(item.rev, tempData.rev_total),
              app_id: item.genre_name,
              children: ch,
              id: item.genre_name,
              revenueDigital: item.digital_rev,
              revenueDigitalChange: computePrecent(item.digital_rev, tempData.dig_total),
              revenuePhysical: item.phy_rev,
              revenuePhysicalChange: computePrecent(item.phy_rev, tempData.phy_total),
            });

            if (item.genre_name.toUpperCase() == expandedKey?.toUpperCase()) {
              expandedKeys.length = 0;
              expandedKeys.push(`record_${index}`);
              setExpandedKeys([...expandedKeys]);
              setSelectId(item.genre_name || '');
              setSelectChildren(item.children || []);
            }
            tempTableData.push(obj);
            if (index < 6) {
              let itemColor = '';
              if (params.entity_type == 'mobile') {
                itemColor = color[index];
              } else {
                itemColor = pcColor[index];
              }
              selectedKeysTemp.push({
                gameId: item.genre_name,
                color: itemColor,
              });
              selectedKeysColorTemp[item.genre_name] = itemColor;
            }

            // 搜索框数据处理
            searchDataTemp.push({
              genreName: item.genre_name,
              displayName: obj.displayName,
            });
          });
      }

      const trendsData = tempData.genre_trends;
      if (trendsData) {
        trendsData.sort(sortTime('date')).map((item: any, key: number) => {
          if (item.genre_tops) {
            tempXaxis.push(
              moment(item.date).format(params.granularity !== 'monthly' ? 'YYYY-MM-DD' : 'YYYY-MM'),
            );
            item.genre_tops.map((obj) => {
              const appId = obj.name;
              const appIdData = tempTrendsData[appId] || {};
              if (params.entity_type == 'mobile') {
                // revenue数据
                let appIdRevenuData = appIdData.revenue || [];
                appIdRevenuData = fixLineData(appIdRevenuData, key);
                appIdRevenuData.push(obj.rev);
                appIdData.revenue = appIdRevenuData;
                // download数据
                let appIdDownloadData = appIdData.download || [];
                appIdDownloadData = fixLineData(appIdDownloadData, key);
                appIdDownloadData.push(obj.download);
                appIdData.download = appIdDownloadData;
              } else {
                // revenue数据
                let appIdRevenuData = appIdData.revenue || [];
                appIdRevenuData = fixLineData(appIdRevenuData, key);
                appIdRevenuData.push((obj.digital_rev + obj.phy_rev).toFixed(2));
                appIdData.revenue = appIdRevenuData;
              }

              appIdData.name = obj.name;
              appIdData.chartDisplayName = getGenreDisplayName(obj.name, 'main');
              appIdData.rawName = obj.name;
              tempTrendsData[appId] = appIdData;
            });
          }
          tempTrendsData.xAxis = tempXaxis;
        });
      }
    }

    if (flag) {
      if (tempData?.start_date && tempData?.end_date && tempData?.end_date != '1970-01-01') {
        setValue([moment(tempData.start_date), moment(tempData.end_date)]);
      } else {
        setValue([moment(), moment()]);
      }
    }

    searchData.length = 0;
    searchData.push(...searchDataTemp);
    setSearchData(searchData);

    setGameTrendsData(tempTrendsData);
    setSelectedKeys(selectedKeysTemp);
    setSelectedAllKeys(selectedKeysTemp);
    setSelectedKeysColor(selectedKeysColorTemp);

    showTableData.length = 0;
    showTableData.push(...tempTableData);
    setTableLength(tempTableData?.length || 0);
    setShowTableData(showTableData);

    allTableData.length = 0;
    allTableData.push(...tempTableData);
    setAllTableData(allTableData);

    filterData(searchKey.length > 0 ? searchKey[0] : '');
    setLineDataLoad(false);
    setTableDataLoad(false);
  };

  /**
   * 通过接口查询公司折线图数据
   * @param {*} selectCode 表格中勾选的id
   * @param {*} params 参数
   */
  const getCompaneiesTrendData = async (selectCode: string[], params: any) => {
    setLineDataLoad(true);
    try {
      const companiesTrend = await getPageData('detail/stats_rank', {
        ...params,
        data_tag: 'companies_trend',
        select_code: selectCode,
      });
      return companiesTrend?.companies_ranks?.company_trends || [];
    } catch (error) {
      setLineDataLoad(false);
      return [];
    }
  };

  /**
   * 查询公司折线图数据，由于公司的接口包含折线图数据，所以采用传入的方式
   * @param {*} selectCode 表格中勾选的id
   * @param {*} gameType 游戏类型，mobile/pc/console
   * @param {*} granularity 粒度
   * @param {*} trendsData 折线图数据
   */
  const setCompaneiesTrendData = (
    selectCode: string[],
    gameType: any,
    granularity: string,
    trendsData: any,
  ) => {
    setLineDataLoad(true);
    const tempTrendsData = {};
    let selectedKeysTemp: any = [];
    const selectedKeysColorTemp: any = {};
    const tempXaxis = [] as any;
    if (trendsData) {
      trendsData.sort(sortTime('date')).map((item, key) => {
        if (item.companies_value) {
          tempXaxis.push(
            moment(item.date).format(granularity !== 'monthly' ? 'YYYY-MM-DD' : 'YYYY-MM'),
          );
          item.companies_value.forEach((obj, index) => {
            const appId = obj.uuid;
            const appIdData = tempTrendsData[appId] || {};

            if (gameType == 'mobile') {
              // revenue数据
              let appIdRevenuData = appIdData.revenue || [];
              appIdRevenuData = fixLineData(appIdRevenuData, key);
              appIdRevenuData.push(obj.rev);
              appIdData.revenue = appIdRevenuData;
              // download数据
              let appIdDownloadData = appIdData.download || [];
              appIdDownloadData = fixLineData(appIdDownloadData, key);
              appIdDownloadData.push(obj.download);
              appIdData.download = appIdDownloadData;
            } else {
              // revenue数据
              let appIdRevenuData = appIdData.revenue || [];
              appIdRevenuData = fixLineData(appIdRevenuData, key);
              appIdRevenuData.push((obj.digtal_rev + obj.physical_rev).toFixed(2));
              appIdData.revenue = appIdRevenuData;
            }
            //
            appIdData.name = obj.name;
            tempTrendsData[appId] = appIdData;
          });
        }
        tempTrendsData.xAxis = tempXaxis;
      });
    }
    selectedKeysTemp = selectCode?.map((item, index) => {
      selectedKeysColorTemp[item] = gameType == 'mobile' ? color[index] : pcColor[index];
      return {
        gameId: item,
        color: gameType == 'mobile' ? color[index] : pcColor[index],
      };
    });

    setGameTrendsData(tempTrendsData);
    setSelectedKeys(selectedKeysTemp);
    setSelectedAllKeys(selectedKeysTemp);
    setSelectedKeysColor(selectedKeysColorTemp);
    setLineDataLoad(false);
  };
  /**
   * 查询公司数据
   * @param {*} params 参数
   * @param {*} flag 是否需要设置默认时间
   */
  const getCompaneiesData = async (params: any, flag: any) => {
    setLineDataLoad(true);
    setTableDataLoad(true);
    const companyRes = await getPageData('detail/stats_rank', {
      ...params,
      data_tag: 'companies',
      genre: [],
    });
    const tempTableData = [] as any;
    const tempTrendsData = {};
    const selectedKeysTemp = [] as any;
    const selectedKeysColorTemp = {};
    const tempXaxis = [] as any;
    const tempData = companyRes?.companies_ranks;

    const searchDataTemp = [] as any;
    setDownloadDataTag('companies');
    if (tempData) {
      const { market_detail_stats_company_rank: rankData, company_trends: trendData } =
        tempData || {};
      const selectedGame = rankData?.slice(0, 6)?.map((item) => item?.uuid) || [];
      const { granularity, entity_type: gameType } = params;
      setCompaneiesTrendData(selectedGame, gameType, granularity, trendData);
      if (rankData) {
        rankData.forEach((item: any, index: number) => {
          const cover = item.cover || alt170170;
          const obj = {
            conutryName: `${item.location_city},${item.location_country}`,
            revenue: item.rev,
            download: item.download,
            conutryFlag: item.country_img || defaltCountryImg,
            name: item.name,
            downloadChange: computePrecentChange(item.download, item.pre_download),
            rank: index + 1,
            revenueChange: computePrecentChange(item.rev, item.pre_rev),
            companyIcon: cover,
            app_id: item.uuid,
            revenueDigital: item.digtal_rev,
            revenueDigitalChange: computePrecentChange(item.digtal_rev, item.pre_digtal_rev),
            revenuePhysical: item.physical_rev,
            revenuePhysicalChange: computePrecentChange(item.physical_rev, item.pre_physical_rev),
          };

          tempTableData.push(obj);
          if (index < 6) {
            let itemColor = '';
            if (gameType == 'mobile') {
              itemColor = color[index];
            } else {
              itemColor = pcColor[index];
            }
            selectedKeysTemp.push({
              gameId: item.uuid,
              color: itemColor,
            });
            selectedKeysColorTemp[item.uuid] = itemColor;
          }

          // 搜索框数据处理
          searchDataTemp.push({
            name: item.name,
            appId: item.uuid,
            companyIcon: cover,
            conutryName: `${item.location_city},${item.location_country}`,
            conutryFlag: item.country_img || defaltCountryImg,
          });
        });
      }
    }

    if (flag) {
      if (tempData?.start_date && tempData?.end_date && tempData?.end_date != '1970-01-01') {
        setValue([moment(tempData.start_date), moment(tempData.end_date)]);
      } else {
        setValue([moment(), moment()]);
      }
    }

    searchData.length = 0;
    searchData.push(...searchDataTemp);
    setSearchData(searchData);

    showTableData.length = 0;
    showTableData.push(...tempTableData);
    setTableLength(tempTableData?.length || 0);
    setShowTableData(showTableData);

    allTableData.length = 0;
    allTableData.push(...tempTableData);
    setAllTableData(allTableData);

    filterData(
      searchKey.length > 0 ? searchKey[0] : '',
      gameSortRelationReverse[params.order_by],
      params.order,
    );
    setLineDataLoad(false);
    setTableDataLoad(false);
  };

  const getCompaniesDataWhenSortChange = async (params: any) => {
    const { selectedGames = [], tableData = [] }: any =
      filterData(
        searchKey.length > 0 ? searchKey[0] : '',
        gameSortRelationReverse[params.order_by],
        params.order,
      ) || {};
    const selectedKeys = selectedGames?.map((item: any) => item.gameId) || [];
    const trendData = await getCompaneiesTrendData(selectedKeys, params);
    const { granularity, entity_type: gameType } = params;
    setCompaneiesTrendData(selectedKeys, gameType, granularity, trendData);
  };

  const resizeHandler = () => {
    const mapChartDom = document.getElementById('trendLine');
    if (mapChartDom) {
      const myMapChart = echarts.init(mapChartDom);
      try {
        myMapChart.resize();
      } catch (e) { }
    }
  };

  const filterData = (keyword: any, sort = sortColunms[0], order = 'desc') => {
    let sortM = '';

    if (['genre', 'operation', 'company'].includes(dataType)) {
      switch (sort) {
        case 'date':
          sortM = 'date';
          break;
        case 'revenue':
          sortM = gameType == 'mobile' ? 'revenue' : 'revenueDigital';
          break;
        case 'revenueChange':
          sortM = gameType == 'mobile' ? 'revenueChange' : 'revenueDigitalChange';
          break;
        case 'downloads':
          sortM = gameType == 'mobile' ? 'download' : 'revenuePhysical';
          break;
        case 'downloadsChange':
          sortM = gameType == 'mobile' ? 'downloadChange' : 'revenuePhysicalChange';
          break;
        case 'gameRevenueA':
          sortM = dataType === 'company' ? 'revenue' : 'revenueAppannie';
          break;
        case 'gameRevenueAChange':
          sortM = dataType === 'company' ? 'revenueChange' : 'revenueAppannieChange';
          break;
        case 'gameRevenueS':
          sortM = 'revenueSensor';
          break;
        case 'gameRevenueSChange':
          sortM = 'revenueSensorChange';
          break;
        case 'gameDownloadA':
          sortM = dataType === 'company' ? 'download' : 'downloadsAppannie';
          break;
        case 'gameDownloadAChange':
          sortM = dataType === 'company' ? 'downloadChange' : 'downloadsAppannieChange';
          break;
        case 'gameDownloadS':
          sortM = 'downloadsSensor';
          break;
        case 'gameDownloadSChange':
          sortM = 'downloadsSensorChange';
          break;
        case 'gameMAUA':
          sortM = 'MAUAppannie';
          break;
        case 'gameMAUAChange':
          sortM = 'MAUAppannieChange';
          break;
        case 'gameMAUS':
          sortM = 'MAUSensor';
          break;
        case 'gameMAUSChange':
          sortM = 'MAUSensorChange';
          break;

        case 'gameRevenueD':
          sortM = 'revenueDigital';
          break;
        case 'gameRevenueDChange':
          sortM = 'revenueDigitalChange';
          break;
        case 'gameRevenueP':
          sortM = 'revenuePhysical';
          break;
        case 'gameRevenuePChange':
          sortM = 'revenuePhysicalChange';
          break;
        case 'MAU':
          sortM = 'MAU';
          break;
        case 'MAUChange':
          sortM = 'MAUChange';
          break;

        case 'genreMobileRevenue':
          sortM = 'revenue';
          break;
        case 'genreMobileDownloads':
          sortM = 'download';
          break;
        case 'genreDigitalRevenue':
          sortM = 'revenueDigital';
          break;

        case 'genrePhysicalRevenue':
          sortM = 'revenuePhysical';
          break;
      }

      // 判断数据中是否有排序字段这个属性，如果有，则继续排序
      // 注意：假设所有数据中，该字段的值全部为空，将不排序
      let has = false;
      allTableData.forEach((item) => {
        if (!has) {
          has = !!item[sortM];
        }
      });
      if (has) {
        let data = [] as any;
        if (sort == 'date') {
          data = allTableData.sort(sortTimeDesc(sortM));
        } else {
          data = allTableData.sort(sortArrDesc(sortM, order));
        }

        data = data.filter((item: any) => {
          if (keyword?.trim() == '') {
            return true;
          }
          if (dataType == 'genre' || dataType == 'company') {
            return item.name.indexOf(keyword) != -1 || item.displayName?.indexOf(keyword) != -1;
          }
        });

        const selectedKeysTemp = [] as any;
        const selectedKeysColorTemp = {} as any;

        let rankNum = 0;
        data.forEach((item: any) => {
          if (keyword.trim() == '') {
            let tempRank;
            if (item.marketNameEn == 'global') {
              tempRank = '-';
            } else if (item.marketNameEn == 'global_wo_china') {
              tempRank = '- ';
            } else {
              rankNum += 1;
              tempRank = rankNum;
            }
            item.rank = tempRank;
          }

          if (selectedKeysTemp.length < 6) {
            let itemColor = '';
            if (gameType == 'mobile') {
              itemColor = color[selectedKeysTemp.length];
            } else {
              itemColor = pcColor[selectedKeysTemp.length];
            }
            selectedKeysTemp.push({
              gameId: item.app_id,
              color: itemColor,
            });
            selectedKeysColorTemp[item.app_id] = itemColor;
          }
        });

        setPageIndex(1);
        setSelectedKeys(selectedKeysTemp);
        setSelectedAllKeys(selectedKeysTemp);
        setSelectedKeysColor(selectedKeysColorTemp);
        setShowTableData(data);
        return {
          selectedGames: selectedKeysTemp,
          tableData: data,
        };
      }
      return {
        selectedGames: selectedKeys,
        tableData: showTableData,
      };
    }
  };

  const changeTableSort = (type: any) => {
    if (dataType == 'game') {
      setPageIndex(1);
      const sortItem = gameSortRelation[type]
        ? gameSortRelation[type]
        : getDefaultSortkeyWhenGames(gameType);
      gameSortFiled.length = 0;
      gameSortFiled.push(sortItem);
      setGameSortFiled(gameSortFiled);
      const _params = {
        market: countryId,
        entity_type: gameType,
        genre: subValue,
        data_tag: dataType,
        start_date: value.length == 2 ? value[0].format('YYYY-MM-DD') : '',
        end_date: value.length == 2 ? value[1].format('YYYY-MM-DD') : '',
        page: 1,
        page_size: pageSize,
        order: 'desc',
        order_by: sortItem,
        granularity: toDateTypeLy[dateType],
      };
      setDownloadOrder('desc');
      setDownloadDataTag(dataType);
      getGamesData(_params, false);
    }
    sortColunms.length = 0;
    sortColunms.push(...[`${type}`]);
    // setSortColunms(sortColunms);
    setSortColunms([type]);

    // getTableColumns();
    if (allTableData?.length > 0) {
      filterData(searchKey.length > 0 ? searchKey[0] : '', sortColunms[0]);
    }
  };

  const onGameTypeChange = (value: string) => {
    if (value == gameType || tableDataLoad) {
      return;
    }
    subValue.length = 0;
    setSubValue(subValue);
    setPageIndex(1);

    genreRef?.current?.reset();

    setIeggGenre([]);
    setDateType('month');
    setValue([]);
    setGameType(value);
    setTrendType('revenue');
    setDataType('operation');
    setPageSize(10);

    setExpandedKeys([]);
    setSelectId('');
    setSelectChildren([]);

    SearchBoxRef?.current?.reset();
    searchKey.length = 0;
    setSearchKey(searchKey);

    const _params = {
      market: countryId,
      entity_type: value,
      genre: [],
      data_tag: 'operation',
      start_date: '',
      end_date: '',
      page: 1,
      page_size: 50,
      order: 'desc',
      order_by: MOBILE_DEFAULT_SORT_KEY,
      granularity: 'monthly',
    } as any;

    setDownloadOrder('desc');
    setDownloadDataTag(dataType);
    gameSortFiled.length = 0;
    gameSortFiled.push(getDefaultSortkeyWhenGames(value));
    // setGameSortFiled('operation')
    // console.log('valuevalue', value);
    getOperationData(_params, true);
    sortColunms.length = 0;
    sortColunms.push(...['date']);
    setSortColunms(sortColunms);
    changeSegment && changeSegment(value);
  };

  const onDataTypeChange = (dataTypeValue: string) => {
    if (dataTypeValue == dataType || tableDataLoad) {
      return;
    }
    setTrendType('revenue');
    setDataType(dataTypeValue);
    setPageIndex(1);

    setExpandedKeys([]);
    setSelectId('');
    setSelectChildren([]);

    SearchBoxRef?.current?.reset();
    searchKey.length = 0;
    setSearchKey(searchKey);

    const _params = {
      market: countryId,
      entity_type: gameType,
      genre: dataTypeValue == 'company' ? [] : subValue,
      data_tag: dataTypeValue,
      start_date: value.length == 2 ? value[0].format('YYYY-MM-DD') : '',
      end_date: value.length == 2 ? value[1].format('YYYY-MM-DD') : '',
      page: 1,
      page_size: 50,
      order: 'desc',
      order_by: gameType == 'mobile' ? 'annie_revenue' : 'digital_revenue',
      granularity: toDateTypeLy[dateType],
      iegg_genre_req: ieggGenre,
    };

    setDownloadDataTag(dataTypeValue);
    let sortC = '';
    switch (dataTypeValue) {
      case 'operation':
        sortC = 'date';
        setPageSize(10);
        getOperationData(_params, false);
        break;
      case 'game':
        setPageSize(50);
        if (gameType == 'mobile') {
          sortC = 'gameRevenueA';
        } else {
          sortC = 'gameRevenueD';
        }
        getGamesData(_params, false);
        break;
      case 'genre':
        setPageSize(50);
        if (gameType == 'mobile') {
          sortC = 'genreMobileRevenue';
        } else {
          sortC = 'genreDigitalRevenue';
        }
        getGenresData(_params, false);
        break;
      case 'company':
        setPageSize(50);
        sortC = gameType == 'mobile' ? 'gameRevenueA' : 'gameRevenueD';
        getCompaneiesData(_params, false);
        break;
    }

    sortColunms.length = 0;
    sortColunms.push(...[sortC]);
    setSortColunms(sortColunms);
    setSortOrder({
      ...initOrder,
      [sortC]: 'desc',
    });
    // genreRef?.current?.reset();
  };

  const componentDefaultValues = {
    // 6个月， 6周， 30天
    date: [moment().subtract(31, 'day'), moment().subtract(1, 'day')],
    week: [moment().subtract(7, 'week').weekday(6), moment().subtract(1, 'week').weekday(5)],
    month: [
      moment().subtract(6, 'month').startOf('month'),
      moment().subtract(1, 'month').endOf('month'),
    ],
  } as any;

  const onChangeRangePicker = (Date: any, type: any) => {
    const startDate = Date[0].format('YYYY-MM-DD');
    const endDate = Date[1].format('YYYY-MM-DD');

    setPageIndex(1);
    const _params = {
      market: countryId,
      entity_type: gameType,
      genre: subValue,
      data_tag: dataType,
      start_date: startDate,
      end_date: endDate,
      page: 1,
      page_size: pageSize,
      order: 'desc',
      order_by: gameSortRelation[sortColunms[0]]
        ? gameSortRelation[sortColunms[0]]
        : getDefaultSortkeyWhenGames(gameType),
      granularity: toDateTypeLy[type],
      iegg_genre_req: ieggGenre,
    };
    setDateType(type);
    setDownloadOrder('desc');
    setDownloadDataTag(dataType);
    setValue(Date);
    if (dataType == 'operation') {
      getOperationData(_params, false);
    } else if (dataType == 'game') {
      getGamesData(_params, false);
    } else if (dataType == 'genre') {
      getGenresData(_params, false);
    } else if (dataType == 'company') {
      getCompaneiesData(_params, false);
    }
  };

  const pcGenreChange = (payload: any) => {
    const { mainGenres, subGenres } = payload;
    setMainGenres(mainGenres);
    setSubGenres(subGenres);

    const iegg_genre_req = [] as any;
    if (payload?.mainGenres?.length > 0) {
      payload.mainGenres.forEach((item: any) => {
        const obj = {
          value: item.value,
          relation: item.relation,
          children: [],
        };
        if (!item.checked) {
          const cTemp = [] as any;
          payload?.subGenres
            ?.filter((k: any) => {
              return item.value == k.parentValue;
            })
            .forEach((oo: any) => {
              cTemp.push({ value: oo.value });
            });
          obj.children = cTemp;
        }
        iegg_genre_req.push(obj);
      });
    }
    const genreSubTemp = [] as any;
    if (payload?.subGenres?.length > 0) {
      payload.subGenres.forEach((item: any) => {
        genreSubTemp.push({ main: item.parentValue, sub: item.value });
      });
    }
    setPageIndex(1);
    const _params = {
      market: countryId,
      entity_type: gameType,
      genre: [],
      data_tag: dataType,
      start_date: value.length == 2 ? value[0].format('YYYY-MM-DD') : '',
      end_date: value.length == 2 ? value[1].format('YYYY-MM-DD') : '',
      page: 1,
      page_size: pageSize,
      order: 'desc',
      order_by: gameSortRelation[sortColunms[0]]
        ? gameSortRelation[sortColunms[0]]
        : getDefaultSortkeyWhenGames(gameType),
      granularity: toDateTypeLy[dateType],
      iegg_genre_req,
    };
    setDownloadOrder('desc');
    setDownloadDataTag(dataType);
    setIeggGenre(iegg_genre_req);
    subValue.length = 0;
    subValue.push(...genreSubTemp);
    setSubValue(subValue);

    if (dataType == 'operation') {
      getOperationData(_params, false);
    } else if (dataType == 'game') {
      getGamesData(_params, false);
    } else if (dataType == 'genre') {
      getGenresData(_params, false);
    }
  };

  //   下载需要的接口参数
  const getGenresReqParams = useCallback(() => {
    // // 初始化使用iegg字段传入
    // // let genresParams;
    const paramsTemp = {
      market: countryId,
      start_date: value.length === 2 ? value[0]?.format('YYYY-MM-DD') : '',
      end_date: value.length === 2 ? value[1]?.format('YYYY-MM-DD') : '',
      page: 1,
      page_size: dataType === 'game' ? tableLength : showTableData?.length || 0,
      genre: dataType === 'company' ? [] : subValue,
      iegg_genre_req: gameType === 'company' ? [] : ieggGenre,
      order: downloadOrder,
      order_by: gameSortRelation[sortColunms[0]]
        ? gameSortRelation[sortColunms[0]]
        : getDefaultSortkeyWhenGames(gameType),
      FileFormat: 0,
      file_name: marketName,
      granularity: toDateTypeLy[dateType],
      data_tag: downloadDataTag,
      dataSource,
      mainGenreList,
      regionOptions,
    };
    return paramsTemp;
  }, [
    value,
    gameType,
    dateType,
    tableLength,
    showTableData,
    dataSource,
    mainGenreList,
    downloadDataTag,
  ]);

  /**
   * 获取参数方法
   * @param dataTag 类型（operation、game、genre、company）
   * @param sortKey 排序字段，详见gameSortRelation
   * @param sortOrder 排序类型
   * @returns 返回接口需要的参数
   */
  const getParams = (dataTag: string, sortKey: string, sortOrder: string) => {
    return {
      data_tag: dataTag,
      end_date: value.length == 2 ? value[1].format('YYYY-MM-DD') : '',
      entity_type: gameType,
      genre: subValue,
      granularity: toDateTypeLy[dateType],
      market: countryId,
      order: sortOrder,
      order_by: gameSortRelation?.[sortKey],
      page: 1,
      page_size: 50,
      start_date: value.length == 2 ? value[0].format('YYYY-MM-DD') : '',
      // select_code: searchKey?.length > 0 ? searchKey : null
    };
  };

  /**
   * 点击排序后请求接口
   * @param dataTag 类型（operation、game、genre、company）
   * @param sortKey 排序字段，详见gameSortRelation
   * @param sortOrder 排序类型
   */
  const handleSortChangeWhenFetch = (dataTag: string, sortKey: string, sortOrder: string) => {
    setPageIndex(1);
    const params = getParams(dataTag, sortKey, sortOrder);
    setDownloadOrder(sortOrder);
    setSortOrder({
      ...initOrder,
      [sortKey]: sortOrder,
    });
    setSortColunms([sortKey]);
    setDownloadDataTag(dataType);
    switch (dataTag) {
      case 'game':
        getGamesData(params, false);
        break;
      case 'companies':
        getCompaniesDataWhenSortChange(params);
        break;
      default:
        break;
    }
  };

  /**
   * 当game类型的表格排序发生变化时的回调
   * @param e SortBy组件返回的事件
   */
  const handleGamesSortChange = (e: any) => {
    const { key, sortVal } = e || {};
    handleSortChangeWhenFetch(dataType, key, sortVal);
  };

  /**
   * 当company类型的表格排序发生变化时的回调
   * @param e SortBy组件返回的事件
   */
  const handleCompanySortChange = (e: any) => {
    const { key, sortVal } = e || {};
    handleSortChangeWhenFetch('companies', key, sortVal);
  };

  useEffect(() => {
    if (dataType === 'game') {
      setShowTableData((prev) => prev.map((item) => formatGameGenreDisplayRow(item)));
      setAllTableData((prev) => prev.map((item) => formatGameGenreDisplayRow(item)));
    }

    if (dataType === 'genre') {
      setShowTableData((prev) => prev.map((item) => formatGenreDisplayRow(item)));
      setAllTableData((prev) => prev.map((item) => formatGenreDisplayRow(item)));
      setSearchData((prev) =>
        prev.map((item) => {
          return {
            ...item,
            displayName: getGenreDisplayName(item.genreName, 'main'),
          };
        }),
      );
      setGameTrendsData((prev) => formatGenreDisplayTrendData(prev));
    }
  }, [dataType, locale, genreMap]);

  const onChangeDataSource = (value: any) => {
    setDataSource(value);
  };
  const onChangeMainGenre = (value: any) => {
    setMainGenreList(value);
  };

  return {
    gameType,
    dataType,
    trendType,
    setTrendType,
    setGameType,
    setDataType,
    gameSortFiled,
    setGameSortFiled,
    setDownloadOrder,
    setDownloadDataTag,
    setPageSize,
    sortColunms,
    setSortColunms,
    getGenresData,
    getGamesData,
    setValue,
    getOperationData,
    resizeHandler,
    showTableData,
    gameSortRelation,
    subValue,
    value,
    pageSize,
    dateType,
    allTableData,
    filterData,
    changeTableSort,
    sumRevenue,
    sumDownload,
    onGameTypeChange,
    onDataTypeChange,
    tableDataLoad,
    selectedKeys,
    setSelectedKeys,
    selectedAllKeys,
    setSelectedKeysColor,
    selectedKeysColor,
    gameTrendsData,
    color,
    pcColor,
    operationTrendsData,
    onChangeRangePicker,
    componentDefaultValues,
    mainGenres,
    subGenres,
    genreRef,
    pcGenreChange,
    searchKey,
    setSearchKey,
    searchData,
    ieggGenre,
    SearchBoxRef,
    lineDataLoad,
    getGenresReqParams,
    tableLength,
    setPageIndex,
    pageIndex,
    expandedKeys,
    setExpandedKeys,
    selectId,
    setSelectId,
    selectChildren,
    setSelectChildren,
    getGamesTrendData,
    getCompaneiesTrendData,
    setCompaneiesTrendData,
    handleGamesSortChange,
    sortOrder,
    getDefaultSortkeyWhenGames,
    handleCompanySortChange,
    dataSource,
    onChangeDataSource,
    mainGenreList,
    onChangeMainGenre,
  };
}
